import { Box, Button, Divider, IconButton, Typography } from "@mui/material";
import React from "react";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const billingHistory = [
  {
    date: "July 20, 2024",
    plan: "Basic",
    price: "$6.99",
    status: "Active",
  },
  {
    date: "June 20, 2024",
    plan: "Basic",
    price: "$6.99",
    status: "Expired",
  },
  {
    date: "May 20, 2024",
    plan: "Basic",
    price: "$6.99",
    status: "Expired",
  },
  {
    date: "April 20, 2024",
    plan: "Pro",
    price: "$9.99",
    status: "Expired",
  },
  {
    date: "March 20, 2024",
    plan: "Pro",
    price: "$9.99",
    status: "Expired",
  },
  {
    date: "February 20, 2024",
    plan: "Basic",
    price: "$6.99",
    status: "Expired",
  },
  {
    date: "January 20, 2024",
    plan: "Basic",
    price: "$6.99",
    status: "Expired",
  },
  {
    date: "December 20, 2023",
    plan: "Basic",
    price: "$6.99",
    status: "Expired",
  },
];

const BillingHistory = ({ onClose, onBack }) => {
  return (
    <>
      <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" p={1}>
        <IconButton aria-label="close" onClick={onBack}>
          <ArrowBackIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.black[100]}` }} />
        </IconButton>
        <Typography variant="h4" pl={1} color={`${PureLightThemeCaaS.colors.alpha.black[100]}`} textAlign={"center"}>
          Billing History
        </Typography>
        <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center">
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.black[100]}` }} />
          </IconButton>
        </Box>
      </Box>
      {billingHistory.map((item, index) => (
        <Box key={index} display="flex" flexDirection="column" justifyContent="center" alignItems="center" pl={1} pr={1} pt={1} gap={1}>
          <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="90%" gap={1}>
            <Typography variant="body2" color={`${PureLightThemeCaaS.colors.alpha.black[100]}`} textAlign="left" flexBasis="40%">
              {item.date}
            </Typography>
            <Typography variant="body2" color={`${PureLightThemeCaaS.colors.alpha.black[100]}`} textAlign="center" flexBasis="35%">
              {item.plan}
            </Typography>
            <Typography variant="body2" color={`${PureLightThemeCaaS.colors.alpha.black[100]}`} textAlign="right" flexBasis="25%">
              {item.price}
            </Typography>
          </Box>
          <Divider
            sx={{
              margin: "auto",
              width: "90%",
              bgcolor: "#999999",
              my: 0.5,
            }}
          />
        </Box>
      ))}
    </>
  );
};

export default BillingHistory;
